import { sourceUpdateFilterCriteria } from "../../../actions/source-actions"

import buildItemConnector from "../../common/build-item-connector"

import SourceFilterForm from "./SourceFilterForm"

export default buildItemConnector(
    "sources",
    true,
    sourceUpdateFilterCriteria
)(SourceFilterForm)